import UploadResumeView from './UploadResumeView'
export default UploadResumeView
